import CreationToolUserRestriction from './user-restriction'

/**
 * Fields available for Super Cut capture and segment editing.
 */
enum CreationToolSuperCutField {
    CaptureTitle = 'CT_SUPER_CUT_FIELD_CAPTURE_TITLE',
    Watermark = 'CT_SUPER_CUT_FIELD_WATERMARK',
    WatermarkFile = 'CT_SUPER_CUT_FIELD_WATERMARK_FILE',
    WatermarkPreview = 'CT_SUPER_CUT_FIELD_WATERMARK_PREVIEW',
    WatermarkPosition = 'CT_SUPER_CUT_FIELD_WATERMARK_POSITION',
    Font = 'CT_SUPER_CUT_FIELD_FONT',
    Crop = 'CT_SUPER_CUT_FIELD_CROP',
}

namespace CreationToolSuperCutField {
    /**
     * Returns all fields (in order) for a specified type (capture or segment)
     */
    export function all(type: 'capture' | 'segment'): CreationToolSuperCutField[] {
        switch (type) {
            case 'capture':
                return [
                    CreationToolSuperCutField.CaptureTitle,
                    CreationToolSuperCutField.Watermark,
                    CreationToolSuperCutField.WatermarkFile,
                    CreationToolSuperCutField.WatermarkPreview,
                    CreationToolSuperCutField.WatermarkPosition,
                    CreationToolSuperCutField.Font,
                ]
            case 'segment':
                return []
        }
    }

    /**
     * Returns the field's title.
     */
    export function title(field: CreationToolSuperCutField): string {
        switch (field) {
            case CreationToolSuperCutField.CaptureTitle:
                return 'Capture Title'
            case CreationToolSuperCutField.Watermark:
                return 'Watermark'
            case CreationToolSuperCutField.WatermarkFile:
                return 'Upload New'
            case CreationToolSuperCutField.WatermarkPreview:
                return 'Previously Used'
            case CreationToolSuperCutField.WatermarkPosition:
                return 'Pick a Corner'
            case CreationToolSuperCutField.Font:
                return 'Custom Font'
            case CreationToolSuperCutField.Crop:
                return 'Crop'
        }
    }

    /**
     * Returns the field's description text.
     */
    export function description(field: CreationToolSuperCutField): string {
        switch (field) {
            case CreationToolSuperCutField.CaptureTitle:
                return 'Add a title'
            default:
                return ''
        }
    }

    /**
     * Returns a user restriction for the field.
     */
    export function userRestriction(field: CreationToolSuperCutField): CreationToolUserRestriction {
        switch (field) {
            default:
                return CreationToolUserRestriction.Everyone
        }
    }

    /**
     * Returns the max character count for the field, if it has one.
     */
    export function maxCharacterCount(field: CreationToolSuperCutField): number {
        switch (field) {
            case CreationToolSuperCutField.CaptureTitle:
                return 50
            default:
                return 0
        }
    }
}

export default CreationToolSuperCutField
